import { lazy } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { IconSizes } from '@pulse-web-ui/icons/lib/icons.constants';

import { AGENT_WORK_SUPPORT_EMAIL } from '@shared/constants';

import { TextLink } from '../links';
import { StateBlock } from '../state-block';

const TechWorksIcon = lazy(
  () => import('@pulse-web-ui/icons/lib/lazy/rgs-tech-works')
);

interface UnableToContinueRegistrationBlockProps {
  testId?: string;
}

export const UnableToContinueRegistrationBlock = ({
  testId = 'unable-to-continue-registration',
}: UnableToContinueRegistrationBlockProps) => {
  const { t } = useTranslation('UNABLE_TO_CONTINUE_REGISTRATION_BLOCK');

  return (
    <StateBlock
      title={t('title')}
      description={
        <Trans
          components={{
            mailLink: <TextLink href={`mailto:${AGENT_WORK_SUPPORT_EMAIL}`} />,
          }}
        >
          {t('description')}
        </Trans>
      }
      icon={<TechWorksIcon size={IconSizes.large} />}
      testId={testId}
    />
  );
};
